import React from "react";
import { motion } from "framer-motion";
import "./AboutBanner.css";
import personImg from "../Assets/course_person.png";
import overlayShape from "../Assets/Triangle.png";

const CourseBanner = () => {
  return (
    <section className="Course-banner">
      <div className="banner-content">
        <motion.h1
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          Turning <span>Learners</span><br />
          <span>into</span> Communicators
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Transforming learners into skilled communicators <br />
          with practical, interactive English training.
        </motion.p>

        <motion.div
          className="banner-buttons"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
        </motion.div>
      </div>

      <div className="banner-images">
        <motion.img
          src={overlayShape}
          alt="Decorative Triangle Overlay"
          loading="lazy"
          className="overlay-shape"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.7 }}
        />
        <motion.img
          src={personImg}
          alt="Person"
          className="person-img"
          animate={{ y: [0, -15, 0] }}
          transition={{ repeat: Infinity, duration: 4, ease: "easeInOut" }}
        />
      </div>
    </section>
  );
};

export default CourseBanner;
